import { gql } from '@apollo/client';
// import Fragments from '../fragments';

export const SEND_MESSAGE = gql`
  mutation SendMessage($input: MessageInput!) {
    sendMessage(input: $input) {
      id
      uuid
      type
      metadata
      message
      sender_id
      receiver_id
      conversation_id
      sender {
        id
        name
        avatar {
          thumb
        }
      }
      receiver {
        id
        name
        avatar {
          thumb
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const SEND_GROUP_MESSAGE = gql`
  mutation SendGroupMessage($input: SendGroupMessageInput!) {
    sendGroupMessage(input: $input) {
      id
      uuid
      message
      type
      metadata
      createdAt
      sender {
        id
        name
        avatar {
          thumb
        }
      }
    }
  }
`;

export const DELETE_GROUP_MESSAGE = gql`
  mutation DeleteGroupMessage($id: ID!) {
    deleteGroupMessage(id: $id) {
      id
    }
  }
`;
